<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <div class="app-screen app-screen--modal-bg" style="padding: 36px 12px 14px;">
    <AppScreensStatusBar :time="t('mock.statusTime')" />

    <!-- Background hint of the panel page (subtle Duty Free + Profile cards behind sheet) -->
    <div style="position: absolute; inset: 36px 12px 14px; opacity: 0.35; pointer-events: none; display: flex; flex-direction: column; gap: 10px;">
      <div style="flex: 1; border: 1.5px solid rgba(31,215,154,0.55); border-radius: 18px; padding: 12px; display: flex; align-items: flex-start; gap: 10px;">
        <div style="width: 36px; height: 36px; border-radius: 50%; background: rgba(31,215,154,0.18); display: grid; place-items: center; color: var(--app-green);">▣</div>
        <div>
          <div style="font-weight: 800; font-size: 16px; line-height: 1.05;">Duty<br/>Free</div>
        </div>
      </div>
      <div style="flex: 0.6; border: 1.5px solid rgba(20,197,219,0.35); border-radius: 18px; padding: 12px; display: flex; align-items: center; gap: 10px;">
        <div style="width: 36px; height: 36px; border-radius: 50%; background: rgba(20,197,219,0.15); display: grid; place-items: center; color: var(--app-cyan);">👤</div>
        <div style="font-weight: 800; font-size: 14px;">{{ t('mock.route.profileCard') }}</div>
      </div>
    </div>

    <!-- Modal sheet on top -->
    <div class="app-sheet" style="position: relative; z-index: 2; margin-top: 22%;">
      <div class="app-sheet__title">{{ t('mock.route.title') }}</div>
      <div class="app-sheet__sub">{{ t('mock.route.hint') }}</div>

      <label class="app-input__label">{{ t('mock.route.fromLabel') }}</label>
      <div class="app-input">
        <span class="app-input__icon">✈</span>
        <span>{{ t('mock.route.fromValue') }}</span>
        <span class="app-input__clear">×</span>
      </div>

      <label class="app-input__label">{{ t('mock.route.toLabel') }}</label>
      <div class="app-input">
        <span class="app-input__icon">✈</span>
        <span>{{ t('mock.route.toValue') }}</span>
        <span class="app-input__clear">×</span>
      </div>

      <div style="display: flex; gap: 8px; margin-top: 16px;">
        <button class="app-btn app-btn--outline-cyan">{{ t('mock.route.cancel') }}</button>
        <button class="app-btn app-btn--cyan">{{ t('mock.route.open') }}</button>
      </div>
    </div>
  </div>
</template>
